export const iconFontAwesomeTransportationCarBurst = (
	<i className="fa-solid fa-car-burst"></i>
);
